import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@recipes/ui/styles.css';
import './lib/i18n';
import { initAppearance } from './lib/appearance/appearance';
import { startInstallCapture } from './lib/pwa/install';
import { App } from './app';

// The boot script has painted the right mode already; this brings the app's state in line.
initAppearance();
// The browser offers the installation with one early event: catch it before anything renders.
startInstallCapture();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
